import { Button, ConditionalRendering, Text } from "@marketplace/ui";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { RouterLink } from "@/components";
import { useIsAuthenticated } from "@/modules/auth/hooks/use-is-authenticated";

const Illustration = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="430"
      height="392"
      fill="none"
      viewBox="0 0 430 392"
    >
      <path
        fill="#C4DAF3"
        d="M16.827 180.113c-51.825 51.72 26.806 127.069 90.471 90.286 34.253-19.79 93.822-33.439 83.77 18.949s-30.381 83.152 56.591 100.689c86.971 17.537 121.372-87.314 96.428-119.638-16.878-5.821-48.109-51.727 24.944-78.768 125.468-46.443 35.742-263.797-75.578-157.164-34.997 39.013-28.966 69.257-113.555 0C95.31-34.789 35.815 11.803 50.708 73.48c20.849 61.676 17.945 54.914-33.88 106.633"
        opacity="0.24"
      ></path>
      <path
        fill="#5599DB"
        d="M89.626 111.716a4.13 4.13 0 0 0-2.686-2.963l-9.54-3.21 18.164-20.677a4.11 4.11 0 0 0 .881-3.78 4.12 4.12 0 0 0-2.66-2.831L81.11 73.99a4.12 4.12 0 0 0-4.678 1.539l-23.34 33.195a4.08 4.08 0 0 0-.54 3.635 4.1 4.1 0 0 0 2.602 2.604l10.217 3.438-8.909 20.574a3.275 3.275 0 0 0 1.163 4.007c1.3.879 3.04.71 4.145-.403l26.773-27.018a4.12 4.12 0 0 0 1.083-3.845M343.75 108.988a4.13 4.13 0 0 1 2.986-2.66l9.829-2.176-15.861-22.494a4.11 4.11 0 0 1-.473-3.853 4.12 4.12 0 0 1 2.946-2.53l13.057-2.892a4.12 4.12 0 0 1 4.488 2.028l19.673 35.491a4.08 4.08 0 0 1 .149 3.672 4.1 4.1 0 0 1-2.863 2.313l-10.526 2.33 6.669 21.405a3.276 3.276 0 0 1-1.583 3.861 3.26 3.26 0 0 1-4.078-.843l-23.745-29.714a4.12 4.12 0 0 1-.668-3.938"
      ></path>
      <path
        fill="#5599DB"
        stroke="#5599DB"
        strokeWidth="6"
        d="M176.676 126.258v83.288h17.587v23.096h-17.587v28.142h-26.608v-28.142H91v-19.551l.542-.776 59.335-84.777.895-1.28zm-26.138 37.98a110 110 0 0 1-2.711 4.222l-.014.02-.013.019-28.68 41.047h30.948v-28.825q0-3.98.09-8.044l.001-.031.001-.033q.178-4.126.356-7.902z"
      ></path>
      <path
        fill="#5599DB"
        stroke="#5599DB"
        strokeWidth="6"
        d="M216.313 122.785c10.638 0 19.661 2.777 26.834 8.538h.001c7.167 5.65 12.332 13.744 15.623 24.052l.308.963c3.129 10.007 4.658 21.857 4.658 35.491 0 10.505-.844 19.979-2.557 28.401l-.001-.001c-1.608 8.13-4.158 15.188-7.712 21.111l-.348.569c-3.659 5.915-8.435 10.518-14.315 13.748l-.573.308c-6.178 3.261-13.524 4.82-21.918 4.82-10.586 0-19.581-2.751-26.754-8.458l-.007-.005-.006-.006c-6.873-5.528-11.904-13.292-15.203-23.094l-.314-.954-.001-.005c-3.271-10.256-4.87-22.421-4.87-36.434 0-13.991 1.446-26.1 4.402-36.271l.002-.011.292-.962c3.067-9.871 7.957-17.688 14.79-23.235l.676-.536c7.06-5.44 16.148-8.029 26.993-8.029Zm0 23.191c-4.998 0-8.7 1.579-11.439 4.554l.001.001c-2.822 3.072-5.068 7.921-6.496 14.887-1.374 6.991-2.079 15.779-2.079 26.411 0 10.692.705 19.509 2.079 26.499l.277 1.279c1.434 6.269 3.595 10.701 6.282 13.579 2.736 2.875 6.42 4.409 11.375 4.409 4.961 0 8.648-1.537 11.385-4.417l.266-.287c2.73-3.019 4.903-7.734 6.285-14.475l.002-.012.003-.011c1.487-6.974 2.253-15.811 2.253-26.564 0-9.974-.647-18.321-1.908-25.081l-.261-1.33c-1.382-6.739-3.556-11.493-6.3-14.574l-.267-.293-.016-.018c-2.739-2.977-6.442-4.557-11.442-4.557Z"
      ></path>
      <path
        fill="#5599DB"
        stroke="#5599DB"
        strokeWidth="6"
        d="M322.57 126.258v83.288h17.587v23.096H322.57v28.142h-26.607v-28.142h-59.068v-19.551l.542-.776 59.334-84.777.896-1.28zm-26.137 37.98a111 111 0 0 1-2.711 4.222l-.014.02-.014.019-28.679 41.047h30.948v-28.825q0-3.98.09-8.044l.001-.031.001-.033q.178-4.126.355-7.902z"
      ></path>
    </svg>
  );
};

export const NotFoundPage = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "404Page"
  });

  const isAuthenticated = useIsAuthenticated();

  return (
    <div
      className={clsx(
        "flex justify-center items-center",
        !isAuthenticated && "w-dvw h-dvh",
        isAuthenticated && "mt-20"
      )}
    >
      <div className="text-center space-y-[34px] w-[522px]">
        <Illustration />
        <div className="text-fjord-grey-500">
          <Text component="h1" type="heading" size="l" className="mb-2">
            {t("title")}
          </Text>
          <Text type="paragraph" size="xl">
            {t("description")}
          </Text>
        </div>
        <ConditionalRendering condition={isAuthenticated}>
          <RouterLink to="/auth/login" className="block">
            <Button variant="primary">{t("backToDashboard")}</Button>
          </RouterLink>
        </ConditionalRendering>
        <ConditionalRendering condition={!isAuthenticated}>
          <RouterLink to="/auth/login" className="block">
            <Button variant="primary">{t("backToLogin")}</Button>
          </RouterLink>
        </ConditionalRendering>
      </div>
    </div>
  );
};
